module.exports = __webpack_public_path__ + "static/media/Czech-republic.f3aa3457.png";